<script lang="ts" setup>
useHead({ title: 'Términos y condiciones de uso' })
</script>

<template>
  <div class="mx-auto prose px-4 text-xl">
    <h1 id="t-rminos-y-condiciones-de-uso-de-la-web-ticketsmart-pe">
      Términos y condiciones de uso de la web TICKETSMART.PE
    </h1>
    <p>
      <strong>TICKETSMART S.A.C.</strong> con RUC No. 20614443228 (en adelante,
      “TICKETSMART.PE”) ofrece una plataforma “online” www.ticketsmart.pe (en
      adelante, el “Sitio Web”) mediante la cual las personas pueden ofrecer
      servicios de Eventos y otros adquirir todo tipo de productos y,
      principalmente, entradas para próximos Eventos que se realicen en Perú,
      así como conocer novedades sobre estos. Tanto el acceso como la
      utilización general del Sitio Web atribuyen a quien lo haga la condición
      de usuario de este, implicando necesariamente la aceptación plena y sin
      reservas de todas y cada una de las disposiciones incluidas en estos
      Términos y Condiciones de Uso. El acceso al Sitio Web a través de la
      identificación del Usuario por medio de su clave privada, se considerará
      registro del Usuario y conlleva necesariamente la aceptación sin reserva u
      objeción alguna de los presentes Términos y Condiciones de Uso.
    </p>
    <p>
      El presente documento contiene los Términos y Condiciones de Uso del Sitio
      Web, mediante la cual la <strong>TICKETSMART.PE</strong> prestará sus
      servicios, por lo que le rogamos que lea detenidamente las presentes
      condiciones antes de utilizar los servicios de TICKETSMART.PE ya que, al
      hacer uso de ellos, usted acepta quedar vinculado por las siguientes
      condiciones:
    </p>
    <h2 id="-qu-es-ticketsmart-pe-">¿Qué es TICKETSMART.PE?</h2>
    <p>
      La Empresa es una persona jurídica de derecho privado constituida según
      las leyes Perú, domiciliada para efectos de los presentes Términos y
      Condiciones de Uso en la ciudad de Chiclayo, Perú.
    </p>
    <p>
      <strong>TICKETSMART.PE</strong> es una empresa dedicada esencialmente a la
      prestación de servicios de todo tipo de eventos a terceros, sean personas
      naturales, jurídicas, tiendas, restaurantes y/o todo tipo de comercios que
      necesiten vender sus productos o servicios vía web a través de la
      plataforma ecommerce de su propiedad. En consecuencia, queda claramente
      establecido que <strong>TICKETSMART.PE</strong> actúa como intermediario,
      a través del Sitio Web, entre Clientes y Organizadores, con la finalidad
      de que puedan actuar como un comercio, tanto en la venta, compra, préstamo
      o intercambio de productos (en adelante, el “Servicio”).
    </p>
    <h2 id="comunicaciones-electr-nicas">Comunicaciones electrónicas</h2>
    <p>
      Cada vez que utilice un servicio de TicketSmart, nos envíe un correo
      electrónico o cualquier otra comunicación desde su dispositivo móvil,
      estará comunicándose electrónicamente con nosotros.
    </p>
    <p>
      Asimismo, nosotros nos pondremos en contacto con usted por el mismo medio
      utilizado o por un medio diferente, como por ejemplo mediante correo
      electrónico, SMS, WhatsApp, Messenger, notificaciones dentro de la Sitio
      Web o a través de cualquier otro servicio de
      <strong>TICKETSMART.PE</strong>.
    </p>
    <p>
      Por tal motivo y para efectos del presente contrato, usted consiente
      recibir comunicaciones de nuestra parte y acepta que todos los avisos y
      otras notificaciones y comunicaciones que le enviemos por medios
      electrónicos satisfacen cualquier requisito de forma escrita, salvo que
      cualquier legislación aplicable con carácter imperativo exigiera una forma
      distinta de comunicación.
    </p>
    <h2 id="definiciones">Definiciones</h2>
    <p>A través del presente documento se usarán las siguientes palabras:</p>
    <ul>
      <li>
        <strong>Cliente</strong>: es el término que define a la persona natural
        o jurídica que se registra en el Sitio Web con el fin de acceder a los
        Servicios.
      </li>
      <li>
        <strong>Organizador</strong>: persona natural mayor de 18 (dieciocho)
        años o persona jurídica que planifica Eventos, los cuales calificarán
        como Servicios.
      </li>
      <li>
        <strong>Usuario</strong>: hace referencia indistintamente al Organizador
        o al Usuario.
      </li>
      <li>
        <strong>Evento</strong>: referido a eventos culturales, académicos,
        deportivos, artísticos, entre otros.
      </li>
      <li>
        <strong>Servicio</strong>: hace referencia indistintamente al servicio
        brindado por TICKETSMART.PE a los organizadores y a los usuarios, según
        lo definido en el numeral 2 del presente documento.
      </li>
      <li>
        <strong>Comisión</strong>: contraprestación pagada por Usuario en
        algunos eventos, previo acuerdo con el organizador.
      </li>
    </ul>
    <h2 id="registro-y-uso-del-sitio-web">Registro y uso del Sitio Web</h2>
    <p>
      Se considera Usuario de <strong>TICKETSMART.PE</strong> a cualquier
      persona natural mayor de dieciocho (18) años que se registre en la Sitio
      Web.
    </p>
    <p>
      El Usuario declara tener capacidad para discernir y que ha accedido a la
      Sitio Web por su propia voluntad, no habiendo sido coaccionado para ello,
      así como que el uso que lleva a cabo de ella lo hace por su sola y única
      cuenta y riesgo
    </p>
    <p>
      Por otro lado, para ser un Usuario registrado y acceder al servicio, usted
      deberá completar el formulario de registro en todos sus campos con datos
      válidos por lo que acepta ser el responsable de salvaguardar la
      confidencialidad de su contraseña y restringir el acceso a su ordenador u
      otros dispositivos.
    </p>
    <p>
      En la medida que lo permita la legislación aplicable, usted acepta asumir
      la responsabilidad que proceda del uso de su cuenta y/o contraseña por lo
      que tendrá la obligación de informarnos inmediatamente en caso tenga
      motivos para creer que su contraseña ha sido puesta en conocimiento de un
      tercero, o ha sido utilizada de una manera no autorizada. Es su
      responsabilidad comprobar que los datos que tenemos de su cuenta estén
      actualizados.
    </p>
    <h2 id="funcionalidades-del-sitio-web">Funcionalidades del Sitio Web</h2>
    <p>
      El Servicio ofrecido tiene como principal objetivo poner a disposición del
      Cliente una herramienta automatizada y autogestionada que le facilite la
      organización de eventos, cuando el cliente sea un organizador, o que
      permita la inscripción en los eventos ofrecidos por los organizadores,
      cuando el cliente sea un usuario.
    </p>
    <p>
      <strong>TICKETSMART.PE</strong> opera únicamente como un punto de venta de
      las entradas del evento, por tanto, no se encarga ni es responsable por la
      organización del mismo; asimismo, no asume responsabilidad alguna por el
      aplazamiento o cancelación del evento, así como por cualquier hecho que
      ocurra antes, durante o con posterioridad a la celebración del mismo.
    </p>
    <h2 id="condiciones-del-sitio-web">Condiciones del Sitio Web</h2>
    <p>
      Para ello, el organizador es el único propietario y coordinador del evento
      y, como tal, posee el derecho exclusivo de decidir en todas las cuestiones
      relacionadas con las entradas; es decir, sobre los precios, cantidades
      disponibles, tiempos de entrega y demás procesos que impliquen la
      comercialización de las entradas.
    </p>
    <p>
      Para ello, el organizador es el único propietario y coordinador del evento
      y, como tal, posee el derecho exclusivo de decidir en todas las cuestiones
      relacionadas con las entradas; es decir, sobre los precios, cantidades
      disponibles, tiempos de entrega y demás procesos que impliquen la
      comercialización de las entradas.
    </p>
    <p>
      Al efectuar la compra de una entrada, el usuario se compromete a comprobar
      que el espectáculo, fecha, horario y precio sean los correctos, pues no se
      aceptarán cambios, devoluciones o reintegros de las entradas o tickets
      adquiridos, con excepción del supuesto de cancelación del evento, en cuyo
      caso se indicará el procedimiento a seguir según indicaciones del
      organizador.
    </p>
    <p>
      El usuario podrá efectuar el pago de las entradas que desea adquirir a
      través de los medios de pago disponibles en el Sitio Web y en las agencias
      o puntos físicos autorizados por <strong>TICKETSMART.PE</strong> y/o el
      organizador no se hacen responsables por cualquier inconveniente que
      ocurra con la tarjeta de crédito o débito ingresada y que impida el cobro
      de la o las entradas; ya sea por consignar erróneamente los datos de una
      tarjeta de crédito o débito, que la tarjeta de crédito o débito no se
      encuentre habilitada para compras por internet, por fallas del sistema del
      banco emisor, por un supuesto fraude electrónico, o por cualquier otra
      causa que impida realizar satisfactoriamente el cobro de las entradas.
    </p>
    <p>
      Las entradas adquiridas no podrán ser utilizadas en ningún caso para su
      reventa y/o aplicación comercial o de promoción alguna, salvo que el
      organizador brinde su autorización por escrito; de lo contrario
      <strong>TICKETSMART.PE</strong> podría anular las entradas adquiridas por
      el usuario para estos fines. Asimismo, TICKETSMART.PE o el organizador
      podrían adoptar acciones legales correspondientes en contra del usuario.
    </p>
    <p>
      <strong>TICKETSMART.PE</strong> podrá anular la entrada o entradas
      adquiridas por el usuario en caso identificara que estas se obtuvieron a
      través de alguna manipulación operacional, sistemática o informática del
      sistema de compras de <strong>TICKETSMART.PE</strong>.
    </p>
    <p>
      El organizador será el responsable de extender y entregar al usuario el
      comprobante fiscal por la adquisición de las entradas que el usuario
      hubiera adquirido. <strong>TICKETSMART.PE</strong> funciona como agente
      recaudador del dinero por las entradas para los eventos que los
      organizadores ponen a disposición, pero no se responsabiliza por entregar
      comprobantes de pago por los mismos, ya que no está realizando una venta
      directa al usuario.
    </p>
    <p>
      El Cliente es absolutamente responsable de custodiar las entradas
      adquiridas, no siendo responsabilidad <strong>TICKETSMART.PE</strong> o el
      organizador por la pérdida de los accesos a sus entradas adquiridas en el
      Sitio Web.
    </p>
    <p>
      <strong>TICKETSMART.PE</strong> se reserva el derecho de modificar, o
      discontinuar el Servicio o cualquier parte del mismo, temporal o
      permanentemente, en cualquier momento y periódicamente; por lo que
      TICKETSMART.PE no será responsable hacia el Cliente o terceras partes por
      ninguna modificación, suspensión o interrupción del Servicio.
    </p>
    <h2 id="condiciones-de-los-eventos">Condiciones de los eventos</h2>
    <p>El organizador se reserva el derecho de admisión.</p>
    <p>
      Al entrar, el público podrá estar sujeto a un control de asistencia según
      la Ley, cualquier persona que se negase a esta condición se le prohibirá
      la entrada al recinto. <strong>TICKETSMART.PE</strong> no tiene injerencia
      en la determinación de las condiciones de seguridad del evento, las que
      serán de exclusiva responsabilidad del organizador. Este último, podrá (i)
      reservarse el derecho de prohibirle al público filmar o grabar este
      evento, y (ii) restringir el ingreso de grabadoras, filmadoras, máquinas
      fotográficas, latas, alimentos, botellas, armas o cualquier objeto que el
      Organizador considere peligroso.
    </p>
    <p>
      El ingreso después de la hora señalada en la entrada está sujeto a las
      reglas del organizador y del establecimiento donde se llevará a cabo el
      evento.
    </p>
    <p>
      El plazo para adquirir entradas o tickets para una actividad puede ser
      variable dependiendo de lo acordado directamente con el organizador de
      dicho evento. En caso no se haya especificado este detalle, los usuarios
      tienen la posibilidad de adquirir tickets hasta un (1) minuto antes de la
      hora de inicio de la actividad correspondiente: ej: Si la actividad
      comienza a las 4:00 p.m. de la tarde, los usuarios pueden adquirir tickets
      hasta las 3:59 p.m.
    </p>
    <p>
      El organizador se reserva el derecho de agregar, modificar o sustituir
      contenido, expositores, artistas, variación de los programas, precios y
      ubicaciones difundidas, así como la capacidad del evento.
    </p>
    <p>
      El usuario reconoce y acepta que <strong>TICKETSMART.PE</strong> pueda
      comunicarse con él, a fin de obtener información respecto de la
      realización del evento para el cual hubiera adquirido una entrada o un
      ticket.
    </p>
    <p>
      Si la fecha de un evento variara por alguna circunstancia, las
      inscripciones serán válidas para la fecha definitiva que fije el
      organizador; en caso el usuario ya no se encontrará interesado en asistir
      al evento, podrá solicitar la devolución de su dinero, única y
      exclusivamente, al organizador.
    </p>
    <p>
      Ante cualquier duda particular respecto al evento que desea participar el
      usuario debe consultar directamente al organizador.
    </p>
    <h2 id="sobre-los-pagos">Sobre los pagos</h2>
    <p>
      En caso se presente algún incidente en la verificación o procesamiento de
      la tarjeta de crédito o débito al momento del cobro,
      <strong>TICKETSMART.PE</strong> le indicará al usuario en la opción web
      “Estado de compra”, qué tipo de incidente se ha suscitado o si el
      procedimiento de compra ha sido exitoso. Si al momento de procesar el
      monto de las entradas, la tarjeta no tuviera saldo o presentase alguna
      observación, se comunicará al usuario para que pueda ingresar otra
      tarjeta.
    </p>
    <p>
      El cobro de las entradas por parte de <strong>TICKETSMART.PE</strong> será
      automático en la mayoría de los casos; sin embargo, en ciertas
      circunstancias puede tomar hasta cuarenta y ocho (48) horas para
      completarse. El usuario deberá tener consideración de este punto al
      momento de decidir el momento de su compra.
    </p>
    <p>
      El usuario acepta que es el único responsable de la información ingresada
      al momento de comprar las entradas compradas.
    </p>
    <p>
      Antes de completar su registro, el usuario debe revisar cuidadosamente los
      términos del evento y condiciones del mismo, ya que una vez completada la
      compra, no se permiten cambios, reintegros y/o devoluciones, salvo las
      admitidas por el organizador. Las entradas solo serán consideradas válidas
      para ingresar el evento siempre que sean pagadas, ya sea a través del
      Sitio Web o mediante el pago ante una agencia habilitada por
      <strong>TICKETSMART.PE</strong> y siempre que el pago se encuentre
      registrado en el sistema de <strong>TICKETSMART.PE</strong>, salvo que el
      evento esté calificado como gratuito. El usuario debe adoptar los recaudos
      necesarios a fin de evitar adquirir y/o poseer una entrada falsa, ya que
      de lo contrario podría ser objeto de las acciones legales
      correspondientes.
    </p>
    <p>
      En caso el usuario solicitara algún cambio debido a: (i) un error en los
      datos consignados en la entrada o ticket adquirido o (ii) un error en la
      elección de la fecha elegida de un evento multi fechas y llevado a cabo
      por el mismo organizador, <strong>TICKETSMART.PE</strong> podrá atender
      dicho pedido siempre que el usuario cancele la suma de US$ 3.00 (Tres y
      00/100 dólares americanos) o el equivalente de la moneda de la entrada
      adquirida. Si el usuario realiza más de un pago en la misma transacción,
      queda a criterio del organizador determinar si considera válido dicho
      registro y si corresponde algún tipo de devolución por un doble pago, de
      ser el caso.
    </p>
    <h2 id="seguridad-en-las-transacciones">Seguridad en las transacciones</h2>
    <p>
      Su compra en el Sitio Web se realizará mediante el sistema de NIUBIZ y
      PAGA EFECTIVO]. Esta pasarela de pagos es segura y cuenta con certificado
      de seguridad SSL, por sus siglas en inglés Secure Socket Layer,
      actualmente usado por las empresas más importantes del mundo para realizar
      transacciones seguras. SSL proporciona autenticación y privacidad de
      información entre TICKETSMART.PE y sus Clientes, mediante el uso de
      criptografía.
    </p>
    <p>
      Sus datos personales e información de pago con el número de su tarjeta de
      crédito o débito son recibidos de forma encriptada y compartida de esa
      manera con nuestro proveedor de medios de pago, lo cual le permitirá
      utilizar sus tarjetas de crédito, débito o prepagadas de las marcas: Visa,
      MasterCard, American Express, Dinners Club, entre otras.
    </p>
    <p>
      Mientras usted se encuentre en el Sitio Web la información de sus medios
      de pago será recibida y manejada de forma absolutamente confidencial,
      según los más altos estándares de seguridad y bajo las leyes vigentes en
      el Perú. Cabe precisar que TICKETSMART.PE no registra ni almacena el
      número de la tarjeta, ni la fecha de expiración, ni el código de
      seguridad.
    </p>
    <h2 id="limitaci-n-de-responsabilidad-de-ticketsmart-pe">
      Limitación de responsabilidad de TICKETSMART.PE
    </h2>
    <p>
      TICKETSMART.PE opera únicamente como un punto de venta de las entradas del
      evento, por tanto, no se encarga ni es responsable por la organización del
      mismo; asimismo, no asume responsabilidad alguna por el aplazamiento o
      cancelación del evento, así como por cualquier hecho que ocurra antes,
      durante o con posterioridad a la celebración del mismo.
    </p>
    <p>
      El Servicio de TICKETSMART.PE no garantiza de ninguna manera que el evento
      al que desea inscribirse vaya a realizarse, si no que se limita a
      notificar a los organizadores de su deseo de participación con las
      selecciones que usted haya realizado y, de ser el caso, transferir al
      organizador del evento los pagos que usted haga a través de alguno de los
      medios de pago habilitados en el Sitio Web y/o en las agencias o puntos
      físicos autorizados por TICKETSMART.PE.
    </p>
    <p>
      Si el evento es cancelado debido a cualquier causa, incluso las que
      respondan a un supuesto de caso fortuito o fuerza mayor, no existirá
      derecho alguno a efectuar contra TICKETSMART.PE reclamos por devoluciones
      o reintegros. El organizador será el único y exclusivo responsable de
      efectuar las devoluciones o reembolsos correspondientes; en este caso el
      organizador tendrá un plazo de hasta noventa (90) días calendario desde la
      fecha estipulada del evento para la devolución del importe correspondiente
      al usuario.
    </p>
    <p>
      TICKETSMART.PE podrá gestionar las devoluciones o reembolsos, siempre que
      ello fuera indicado y acordado entre TICKETSMART.PE y el organizador. En
      caso TICKETSMART.PE gestione la devolución del dinero, el usuario deberá
      seguir las indicaciones, las mismas que podrán ser comunicadas por correo
      electrónico, por el Sitio Web y/o las cuentas de redes sociales (Facebook,
      Twitter e Instagram) de TICKETSMART.PE.
    </p>
    <p>
      Cuando el usuario de la entrada tenga derecho a un reembolso, el reembolso
      se limitará al precio pagado al organizador por la entrada. Solo el
      usuario cuyo nombre figure en el formulario de solicitud tendrá derecho a
      pedir un reembolso.
    </p>
    <p>
      TICKETSMART.PE no estará obligada a efectuar devoluciones de dinero por
      errores de fechas, valores registrados, nombres de eventos, calidad de los
      eventos, o en general por causas ajenas a responsabilidades propias.
    </p>
    <p>
      TICKETSMART.PE no garantiza la habilitación de todos los métodos de pago
      al momento de realizar la compra. Esto se debe a que TICKETSMART.PE
      utiliza métodos y sistemas de seguridad para compras en línea lo que puede
      generar que ciertas modalidades de pago no estén habilitadas según
      análisis de estos sistemas de seguridad.
    </p>
    <p>
      TICKETSMART.PE no asume responsabilidad por el retraso, borrado, entrega
      equivocada o falla al guardar cualquier información del usuario, o sus
      criterios de personalización.
    </p>
    <p>
      TICKETSMART.PE no asume responsabilidad por errores técnicos, como fallas
      del equipo o programas informáticos, o fallas de internet o de equipos de
      impresión que utilice el usuario para acceder al Sitio Web, así como
      tampoco el bloqueo de seguridad por parte de nuestro sistema de cobros por
      diversos motivos establecidos para evitar el fraude que impida el
      continuar con la compra de manera regular.
    </p>
    <p>
      Estamos comprometidos a proporcionarle los más altos estándares de
      servicio. Puede encontrar información sobre nuestro procedimiento en
      nuestra web
      <a href="https://www.ticketsmart.pe">https://www.ticketsmart.pe</a> o
      escribirnos un correo a contacto@ticketsmart.pe Conforme a lo establecido
      en el Código de Protección y Defensa del Consumidor, Ley Nº 29571,
      TICKETSMART.PE pone a su disposición en el Sitio Web, un libro de
      reclamaciones virtual donde usted podrá formular una queja o reclamo
      respecto del Servicio ofrecido.
    </p>
    <h2 id="privacidad">Privacidad</h2>
    <p>
      Toda información personal que facilite o se recoja a través de la Sitio
      Web será tratada principalmente por TICKETSMART.PE y sus Usuarios. La
      información personal que recabamos de nuestros Usuarios nos ayuda a
      personalizar y mejorar continuamente nuestros servicios.
    </p>
    <p>
      De acuerdo con la Ley N° 29733 – Ley de Protección de Datos Personales y
      su Reglamento, aprobado por el Decreto Supremo No. 003-2013-JUS, se
      entiende por datos personales toda información sobre una persona natural
      que la identifica o hace identificable a través de medios que pueden ser
      razonablemente utilizados. El Usuario autoriza que sus datos sean puestos
      a disposición en la Sitio Web para su interacción con los demás Usuarios.
    </p>
    <p>
      En tal sentido, para la utilización de la Sitio Web, TICKETSMART.PE
      necesitará la información básica conforme se encuentra detallada en el
      punto 6. de los presentes Términos y Condiciones de Uso. Todos estos datos
      serán recopilados con la finalidad de hacer un correcto uso del servicio.
    </p>
    <h2 id="condiciones-de-uso">Condiciones de uso</h2>
    <p>
      Por regla general, el acceso a los servicios de la Sitio Web estará
      condicionada al registro previo del Usuario, quien deberá completar todos
      los campos del formulario de inscripción con datos válidos.
    </p>
    <p>
      Quien aspire a convertirse en Usuario deberá verificar que la información
      que pone a disposición sea exacta, precisa y verdadera, por lo que asumirá
      el compromiso de actualizar sus datos personales cada vez que los mismos
      sufran modificaciones.
    </p>
    <p>
      TICKETSMART.PE podrá utilizar diversos medios para identificar a los
      Usuarios, pero no se responsabiliza por la certeza de los datos personales
      que sus Usuarios pongan a su disposición. Los Usuarios garantizan y
      responden, en cualquier caso, de la veracidad, exactitud, vigencia y
      autenticidad de los datos personales puestos a disposición de
      TICKETSMART.PE.
    </p>
    <p>
      A los efectos de adquirir la condición de Usuario de TICKETSMART.PE, el
      Usuario deberá completar el formulario de registro, aceptar la Política de
      Privacidad y los presentes Términos y Condiciones de Uso. De esta forma,
      como Usuario de TICKETSMART.PE usted podrá hacer uso de los servicios que
      se ofrecen.
    </p>
    <h2
      id="acceso-a-la-cuenta-personal-y-obligaci-n-de-confidencialidad-de-la-clave-de-seguridad-"
    >
      Acceso a la cuenta personal y obligación de confidencialidad de la Clave
      de Seguridad.
    </h2>
    <p>
      Para ser un Usuario de la Sitio Web, usted tendrá acceso a una cuenta
      personal donde le pediremos que nos brinde la siguiente información de
      manera obligatoria:
    </p>
    <ul>
      <li>Nombre y apellido</li>
      <li>Correo electrónico</li>
      <li>Domicilio</li>
      <li>Teléfono</li>
      <li>Ubicación geográfica</li>
      <li>
        Clave de seguridad personal elegida (“Clave de Seguridad”)
        Adicionalmente, de manera voluntaria, podrá brindarnos su
        geolocalización para proporcionar a los demás usuarios su ubicación
        exacta en caso realice una transacción
      </li>
    </ul>
    <p>
      La Clave de Seguridad es personal e intransferible. El Usuario se obliga a
      mantener en estricta confidencialidad su Clave de Seguridad. El Usuario
      será, en todo caso, responsable por todo daño, perjuicio, lesión o
      detrimento que del incumplimiento de esta obligación de confidencialidad
      se genere por cualquier causa.
    </p>
    <p>
      La cuenta es personal, única e intransferible, y está prohibido que un
      mismo Usuario registrado registre o posea más de una cuenta. En caso de
      que TICKETSMART.PE detecte distintas cuentas que contengan datos
      coincidentes, podrá cancelarlas, suspenderlas o inhabilitarlas, a su sola
      discreción, siendo el mismo motivo suficiente para dar de baja al Usuario,
      incluso en su primera cuenta.
    </p>
    <p>
      El Usuario será responsable por todas las operaciones efectuadas desde su
      cuenta, pues el acceso a la misma está restringido al ingreso y uso de su
      Clave de Seguridad, de conocimiento exclusivo del Usuario y cuya
      confidencialidad es de su exclusiva responsabilidad. El Usuario se
      compromete a notificar a TICKETSMART.PE en forma inmediata y por medio
      idóneo, fehaciente, eficiente y eficaz, cualquier uso no autorizado de su
      cuenta, así como el ingreso por terceros no autorizados a la misma.
    </p>
    <p>
      Se encuentra prohibida la venta, cesión, transferencia o transmisión de la
      cuenta bajo cualquier título, ya sea oneroso o gratuito, en cuyo caso la
      misma será dada de baja sin previo aviso.
    </p>
    <p>
      TICKETSMART.PE se reserva el derecho de rechazar cualquier solicitud de
      registro o de cancelar un registro previamente aceptado, cuando a su sola
      discreción considere que no se ha dado cumplimiento a la totalidad de las
      pautas establecidas en los Términos y Condiciones de Uso, sin que esté
      obligado a comunicar o exponer las razones de su decisión y sin que ello
      genere derecho a indemnización o resarcimiento alguno a favor del Usuario
      registrado alcanzado por dicha decisión.
    </p>
    <p>
      Cualquier derecho a su cuenta de TICKETSMART.PE – TicketSmart ID - o
      contenidos dentro de su cuenta se extinguen a la muerte del usuario u
      organizador, o extinción del organizador, en caso de tratarse de una
      persona jurídica. Sus Datos de Registro y cierta información se encuentran
      sujetos a nuestra Política de Privacidad.
    </p>
    <h2 id="obligaci-n-de-mantener-actualizados-los-datos-personales-">
      Obligación de mantener actualizados los Datos Personales.
    </h2>
    <p>
      Los datos personales introducidos por todo Usuario en la Sitio Web deberán
      ser exactos, actuales y veraces en todo momento. TICKETSMART.PE se reserva
      el derecho de solicitar algún comprobante y/o dato adicional a efectos de
      corroborar los datos personales, y de suspender temporal y/o
      definitivamente a aquellos Usuarios cuyos datos no hayan podido ser
      confirmados.
    </p>
    <h2 id="pol-tica-de-cancelaci-n">Política de cancelación</h2>
    <p>
      El Cliente acepta que TICKETSMART.PE puede, bajo ciertas circunstancias y
      sin necesidad de notificación previa, cancelar y terminar inmediatamente
      su cuenta TICKETSMART.PE, cualquier dirección de correo electrónico
      asociada y su acceso al Servicio. Entre las causales de terminación se
      incluyen, sin limitarse: (a) incumplimientos o violaciones a estos
      Términos y Condiciones o a otros acuerdos o lineamientos incorporados; (b)
      requerimientos de autoridades legales o gubernamentales; (c) su solicitud
      (terminación de cuenta por requerimiento del Cliente); (d) terminación o
      modificaciones sustanciales al Servicio (o cualquier parte del mismo); (e)
      problemas técnicos o de seguridad inesperados; (f) períodos de inactividad
      prolongados. La terminación de su cuenta TICKETSMART.PE incluye: (a) la
      cancelación del acceso a todas las ofertas ofrecidas en el marco del
      Servicio; (b) el borrado de su clave y de toda la información relacionada,
      archivos y de todo el contenido asociado con o dentro de su cuenta (o de
      cualquier parte de la misma); y (c) prohibir el uso posterior del
      Servicio. Asimismo, el Cliente acepta que todas las causales de
      terminación con causa podrán ser invocadas por TICKETSMART.PE a su única
      discreción. TICKETSMART.PE no será responsable frente al Cliente, ni
      frente a ningún tercero por cualquier terminación de su cuenta.
    </p>
    <p>
      En caso el Cliente decida no seguir utilizando los servicios de
      TICKETSMART.PE y opte por dar de baja su cuenta en el Sitio Web, éste
      deberá comunicarlo a TICKETSMART.PE vía correo electrónico a
      contacto@ticketsmart.pe, acompañando la siguiente documentación:
    </p>
    <p>
      Copia de DNI del Cliente por ambos lados (Puede ser escaneo). Si el
      Cliente actúa por medio de otra persona o representante legal, se deberá
      acompañar el poder o título que confirme que este último se encuentra
      autorizado para actuar como tal y solicitar la cancelación de la cuenta
      del Cliente. Correo electrónico del Cliente a fin de brindar respuesta a
      su solicitud. La solicitud de desafiliación o cancelación de cuenta será
      atendida en un plazo máximo de diez (10) días contados desde el día
      siguiente de su presentación, y la desafiliación efectiva se llevará a
      cabo en un plazo aproximado de treinta (30) días calendario. El plazo
      anteriormente indicado también aplica para las solicitudes de
      desafiliación que sean formuladas a través de los canales oficiales de
      TICKETSMART.PE en sus redes sociales, en cuyo caso se dará respuesta al
      Cliente a través de dichos medios. De no ser posible atender la solicitud
      del Cliente por falta de información o de precisión, TICKETSMART.PE se lo
      comunicará oportunamente.
    </p>
    <h2 id="publicaciones-realizadas-en-el-sitio-web">
      Publicaciones realizadas en el Sitio Web
    </h2>
    <p>
      El organizador reconoce que TICKETSMART.PE puede establecer prácticas
      generales y límites con respecto al uso del Servicio, incluyendo, pero sin
      limitarse, el número máximo de días que los eventos estarán disponibles
      para registrarse, anuncios publicados en el newsletter/boletín de
      mensajes, redes sociales u otros contenidos cargados en el Sitio Web, el
      número máximo de mensajes de correo electrónico que puedan ser enviados o
      recibidos por una cuenta en el marco de la ejecución del Servicio, los
      montos máximos y mínimos que pueden ser cobrados por un evento, la
      cantidad de entradas o tickets que pueden emitirse, el tamaño máximo de
      cualquier mensaje de correo electrónico que pueda ser mandado o recibido
      por una cuenta en el marco de la ejecución del Servicio, el espacio máximo
      de disco que será asignado en los servidores de TICKETSMART.PE para su
      beneficio, y el número máximo de veces que el organizador podrá tener
      acceso al Servicio en un período dado, así como la máxima duración de cada
      uno de los accesos.
    </p>
    <p>
      El organizador acepta que TICKETSMART.PE no tiene responsabilidad u
      obligación por el borrado o falla en el almacenamiento de mensajes u otras
      comunicaciones, o cualquier otro Contenido mantenido o transmitido en el
      marco de la ejecución del Servicio. El organizador acepta que
      TICKETSMART.PE se reserva el derecho de dar de baja cuentas que han estado
      inactivas por un período prolongado de tiempo y el derecho de modificar
      estas prácticas generales y límites en cualquier momento, a su solo
      arbitrio, sin necesidad de previa notificación.
    </p>
    <h2 id="incumplimiento">Incumplimiento</h2>
    <p>
      El incumplimiento de cualquiera de las obligaciones establecidas en las
      presentes condiciones supondrá la automática eliminación de la cuenta del
      Usuario y habilitará a TICKETSMART.PE a reclamar cuantos daños y/o
      perjuicios pueda ocasionársele. Asimismo, si como consecuencia de la
      eliminación de una cuenta por incumplimiento de los Términos y Condiciones
      de Uso de los servicios ofrecidos por TICKETSMART.PE, el Usuario no puede
      recibir/prestar un servicio, será informado por TICKETSMART.PE de esta
      circunstancia y no podrán reclamar a TICKETSMART.PE por los daños y/o
      perjuicios que pudieran ser ocasionados.
    </p>
    <h2 id="l-mite-de-garant-as">Límite de garantías</h2>
    <p>
      El Cliente expresamente comprende y conviene que el uso del servicio es
      bajo su propio riesgo. El Servicio es provisto tal cual es y según se
      encuentre disponible, por lo que TICKETSMART.PE no otorga garantía de
      ningún tipo, ya sea expresa o implícita, incluyendo -sin limitación- a las
      garantías implícitas de comercialidad, aptitud para un propósito en
      particular, y no infracción. TICKETSMART.PE no garantiza que: (i) el
      Servicio se ajustará a sus necesidades; (ii) el Servicio será
      ininterrumpido, puntual, seguro o libre de error; (iii) los resultados que
      puedan ser obtenidos del uso del Servicio sean veraces o confiables y (iv)
      la calidad de cualquier producto, servicio, información u otro material
      comprado u obtenido por usted a propósito de la ejecución del Servicio, se
      ajustará a sus expectativas. Cualquier material descargado o de cualquier
      otra forma obtenido por medio del uso del Servicio es hecho bajo su propia
      discreción y riesgo, y usted será absolutamente responsable por cualquier
      daño al sistema de su computadora o perdida de datos que resulten de la
      descarga de cualquiera de estos materiales. Ningún consejo o información,
      ya sea oral o escrito, obtenido por usted de parte TICKETSMART.PE, o por
      medio del uso del Servicio, constituirá garantía alguna, a no ser que se
      encuentre expresamente establecido en los Términos y Condiciones. Un
      reducido porcentaje de usuarios puede experimentar, cuando son expuestos a
      cierto patrón de luces o fondos en un monitor de computadora o cuando usa
      el Servicio. Ciertas condiciones pueden inducir síntomas epilépticos no
      detectados interiormente, inclusive en personas que no tienen historia de
      ataques de epilepsia. Si el Cliente o cualquiera en su familia, tiene
      condición de epiléptico, consulte a su médico con anterioridad al uso del
      servicio. En caso de que experimente alguno de los siguientes síntomas
      mientras usa el Servicio: mareo, tensión alterada, dolores oculares o
      musculares, pérdida del conocimiento, desorientación, movimientos
      involuntarios o convulsiones; interrumpa el acceso del Servicio
      inmediatamente y consulte a su médico.
    </p>
    <h2 id="licencia-de-uso">Licencia de uso</h2>
    <p>
      TICKETSMART.PE le concede a usted una licencia limitada no exclusiva, no
      transferible y no sub-licenciable, de acceso y utilización, a los
      servicios de TICKETSMART.PE para fines personales no comerciales. Dicha
      licencia no incluye derecho alguno de reventa ni de uso comercial de los
      Servicios de TICKETSMART.PE ni de sus contenidos, ni le otorga derecho a
      compilar ni utilizar lista alguna de Alimentos, descripciones o precios.
    </p>
    <p>
      Tampoco incluye el derecho a realizar ningún uso derivado de los Servicios
      de TICKETSMART.PE ni de sus contenidos, ni a descargar o copiar
      información de cuenta alguna para el beneficio de otra empresa, ni el uso
      de herramientas o robots de búsqueda y extracción de datos o similar.
    </p>
    <p>
      No está permitida la reproducción, duplicación, copia, venta, reventa o
      explotación de ningún tipo de los Servicios que le ofrece el Sitio Web, ni
      de parte alguna de los mismos con fines comerciales, en cada caso sin
      nuestro previo consentimiento por escrito.
    </p>
    <p>
      Tampoco está permitido utilizar técnicas de framing para introducir
      cualquier marca comercial, logotipo u otra información protegida por
      derechos de autor (incluyendo imágenes, texto, diseños de página o
      formatos) de TICKETSMART.PE sin el correspondiente consentimiento previo
      por escrito.
    </p>
    <p>
      Cualquier incumplimiento por parte de usted de estos Términos y
      Condiciones supondrá la anulación de su licencia de uso de los Servicios
      de TICKETSMART.PE.
    </p>
    <h2 id="modificaci-n-de-los-t-rminos-y-condiciones-y-acceso">
      Modificación de los Términos y Condiciones y acceso
    </h2>
    <p>
      TICKETSMART.PE se reserva el derecho de agregar, cambiar o modificar de
      otro los Términos y Condiciones. El acceso o uso del Sitio Web por parte
      del usuario supone su aceptación de las Condiciones actualizadas o
      modificadas. Es su responsabilidad revisar esta página periódicamente para
      identificar posibles cambios. Puede revisar la versión actualizada de los
      Términos y Condiciones, en cualquier momento en esta página.
    </p>
    <p>
      TICKETSMART.PE se reserva el derecho de negar el acceso al Sitio Web y a
      los servicios que ofrece a cualquier persona, en cualquier momento y bajo
      cualquier motivo, incluyendo, pero no limitándose al desconocimiento de lo
      estipulado en este Contrato.
    </p>
    <p>
      De conformidad con las reglas de responsabilidad civil, el Cliente
      reconoce y acepta que TICKETSMART.PE podrá solicitar una indemnización por
      los reclamos y gastos en los que haya incurrido TICKETSMART.PE a
      consecuencia del desconocimiento o infracción a lo estipulado en estos
      Términos y Condiciones de parte del Cliente, los que incluyen honorarios
      profesionales de abogados, tasas judiciales o administrativas y cualquier
      daño emergente o lucro cesante.
    </p>
    <p>
      Nos reservamos el derecho a denegar el acceso al servicio, a cancelar
      cualesquiera cuentas y a eliminar o modificar cualquier contenido en caso
      de que el Cliente incumpliera la legislación aplicable, los presentes
      Términos y Condiciones o cualesquiera otros términos y condiciones o
      políticas aplicables.
    </p>
    <h2
      id="derechos-de-autor-derechos-de-propiedad-intelectual-y-derechos-sobre-base-de-datos"
    >
      Derechos de autor, derechos de propiedad intelectual y derechos sobre base
      de datos
    </h2>
    <p>
      TICKETSMART.PE está protegido por los derechos de propiedad intelectual.
      Todos los derechos involucrados como por ejemplo el contenido, el diseño
      visual, logos y eslogan que forman parte del contenido y del Servicio,
      pertenecen a TICKETSMART.PE. En base a ello, se prohíbe utilizar,
      codificar, copiar, distribuir, transmitir o comercializar los derechos
      involucrados sin el permiso expreso por escrito de TICKETSMART.PE. El
      Cliente no adquiere ningún derecho de propiedad intelectual por el uso del
      Servicio y del Sitio Web, no siendo considerado una autorización ni
      licencia para utilizar el Servicio y el Sitio Web con fines distintos a
      los mencionados en el presente Contrato. El Cliente reconoce y acepta y
      acuerda que el Servicio y cualquier software necesario usado en conexión
      con el Servicio (el “Software”) contiene propiedad e información
      confidencial que se encuentra protegida bajo las leyes aplicables de
      propiedad intelectual y de otra naturaleza. Además, el Cliente reconoce y
      acepta que el contenido incluido en publicidad de anunciantes o
      información presentada por el organizador por medio del Servicio o
      anunciantes, está protegida por los derechos de propiedad intelectual.
    </p>
    <p>
      Con excepción a lo expresamente autorizado por TICKETSMART.PE o los
      anunciantes, el Cliente se compromete a no modificar, alquilar, arrendar,
      prestar, vender, distribuir o crear obras derivadas basadas en el Servicio
      o en el Software, en todo o en parte. código objeto de su Software en una
      sola computadora; siempre y cuando no copie, modifique, haga una obra
      derivada de, haga ingeniería inversa, haga ensamblaje inverso, o de
      cualquier otra manera intente descubrir alguno de los códigos fuente,
      venda, asigne, sublicencie, otorgue en garantía o de cualquier otra forma
      transfiera cualquier derecho en el Software, o permita a terceros hacer
      cualquiera de estas acciones, el Cliente se obliga a no modificar de
      ninguna manera el Software o a usar versiones modificadas del Software,
      incluyendo, sin limitación, con el propósito de obtener acceso no
      autorizado al Servicio. El Cliente acuerda no acceder al Servicio por
      cualquier otro medio distinto de la interface provista por TICKETSMART.PE
      para acceder al Servicio.
    </p>
    <h2 id="legislaci-n-aplicable">Legislación aplicable</h2>
    <p>
      Estos Términos y Condiciones de Uso se rigen y serán aplicados e
      interpretados de acuerdo con la legislación peruana. Cualquier disputa que
      surja en su aplicación se someterá al conocimiento de los tribunales con
      jurisdicción en Chiclayo, Perú.
    </p>
    <h2 id="actualizaci-n-de-los-t-rminos-y-condiciones">
      Actualización de los términos y condiciones
    </h2>
    <p>
      TICKETSMART.PE podrá realizar actualizaciones y cambios sobre los Términos
      y Condiciones, de acuerdo a cambios y/o exigencias regulatorias, o por
      adecuaciones propias del Servicio establecidas a criterio de
      TICKETSMART.PE. Toda actualización entrará en vigencia desde su
      publicación a través del Sitio Web. Finalmente, TICKETSMART.PE realizará
      los esfuerzos necesarios para enviar una notificación de dicha
      actualización al Cliente que se encuentre operando a través de su correo
      registrado o haciendo su publicación en el Sitio Web.
    </p>
    <h2 id="contacto">Contacto</h2>
    <p>
      Para cualquier pregunta respecto de estas Condiciones, por favor
      contáctenos a: contacto@ticketsmart.pe
    </p>
  </div>
</template>
